var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'interactjs-drop-zone drop-zone',
         _vm.state.dragging ? 'drop-zone-highlight' : '',
         _vm.size + '-drop-zone',
         _vm.additionalClasses
    ],attrs:{"is-first":_vm.isFirst,"is-bottom":_vm.isBottom,"dropZoneId":_vm.dropZoneId,"global-panel":_vm.panel.isMaster,"panel-uuid":_vm.panel.uuid,"previous-element":_vm.previousElement}},[_c('div',{staticClass:"drop-zone-content"})])}
var staticRenderFns = []

export { render, staticRenderFns }